import {useTranslation} from '@/translations/i18n'
import {Content, AnswerField} from '../atoms/Atoms'
import {forwardRef} from 'react'
import {categoryFormatToLabel, categoryToLabel} from '@/features/experience-shell/utils'
import {RemapExperienceForViewOnly} from '@/features/experience-view-only/types'

export const ExperienceStep = forwardRef<HTMLDivElement, {experience: RemapExperienceForViewOnly}>(
    ({experience}, ref) => {
        const {t} = useTranslation()
        const category = experience.category.category?.keyName
        const format = experience.category.subCategory?.keyName

        return (
            <Content title={t('experience_shell:step_experience')} ref={ref}>
                <AnswerField
                    labelTitle={t('experience_shell:category')}
                    hasValue={!!category && category != 'generic'}
                    value={
                        category && category != 'generic'
                            ? t(categoryToLabel[category as keyof typeof categoryToLabel])
                            : undefined
                    }
                />
                <AnswerField
                    labelTitle={t('experience_shell:format')}
                    hasValue={!!format}
                    value={format ? t(categoryFormatToLabel[format]) : undefined}
                />
            </Content>
        )
    }
)

ExperienceStep.displayName = 'ExperienceStep'
